import type { MetaDescriptor } from '@remix-run/react';
import { parseURL } from '@archipro-website/top-navigation';
import { hasFeature, type FeatureFlags } from '~/modules/root';
import { noIndexNoFollow } from '@modules/seo/util/no-index-no-follow';

export const NON_FILTER_KEYS = ['page', 'sort', 'pageSize', 'updateUserPrefs'];

/**
 * Index page for no filter product category or leaf product category with one color or mafilter
 * @param metaDescriptors
 * @param url
 * @param customSeoOnFilters
 * @param featureSet
 * @returns
 */
export const noIndexProductCategory = (
    metaDescriptors: MetaDescriptor[],
    url: string,
    customSeoOnFilters = false,
    featureSet?: FeatureFlags
): MetaDescriptor[] => {
    const { basePath, params } = parseURL(url);
    if (!basePath.startsWith('/products')) return metaDescriptors;

    let filterCount = 0;
    const keys: string[] = [];
    Object.keys(params).forEach((key) => {
        if (NON_FILTER_KEYS.includes(key)) return;
        const values = params[key];
        filterCount += Array.isArray(values) ? values.length : 1;
        keys.push(key);
    });

    const indexableKeys = [];
    if (featureSet && hasFeature(featureSet, 'seo_indexable_filter_colour')) {
        indexableKeys.push('colors');
    }

    if (featureSet && hasFeature(featureSet, 'seo_indexable_filter_material')) {
        indexableKeys.push('materials');
    }

    const indexPage =
        !filterCount ||
        (customSeoOnFilters &&
            filterCount === 1 &&
            keys[0] &&
            indexableKeys.length &&
            indexableKeys.includes(keys[0]));

    return noIndexNoFollow(true, true, !!indexPage, metaDescriptors);
};
